export const EventOrderStatuses = {
    PAID: 'paid',
    PENDING: 'pending',
    REJECTED: 'rejected',
    PARTIAL_REFUND: 'partial-refund',
    REFUNDED: 'refunded',
    LATE_ORDERS: 'lateOrders',
    CANCELlATION_WITHOUT_REFUND: 'cancellation_without_refund',
    DIVIDE_ORDER_PENDING: "divide_order_pending",
    DIVIDE_ORDER_ACTIVE: "divide_order_active",
    DIVIDE_ORDER_COMPLETE: "divide_order_complete",
    DIVIDE_ORDER_FAILED: "divide_order_failed"
}

export const CouponTypes = {
    FIXED: 'fixed',
    PERCENTAGE: 'percentage',
    CUSTOM_PRICE: "customPrice",
}

export const AppEnv = {
    PROD: 'live',
    STAGING: 'staging',
    LOCAL: 'local',
}

export const LinksUtm = {
    PRIMARY: "PRIMARY"
}

export const IncUtmActionTypes = {
    UNIQUE_VIEWS: "UNIQUE_VIEWS",
    VIEWS: "VIEWS",
    CLICKS: "CLICKS"
}

export const CollaboratesRoles = {
    SCANNER: "scanner",
    READER: "reader",
    TRAINER: "trainer",
    EDITOR: "editor",
    ADMIN: "admin",
    PROMOTER: "promoter",
    CASHIER: "cashier",
}

export const AuthTypes = {
    LOGIN: 'login',
    REGISTER: 'register',
}

export const GeneralFieldsName = {
    B_DAY: 'birthday',
    L_NAME: 'lname',
    F_NAME: 'fname',
    EMAIL: 'email',
    PHONE: 'phone',
    GENDER: 'gender',
    SOCIAL_LINK: 'socialLink',
    EMAIL_MARKETING: 'isAllowMarketingDelivery',
    BUSINESS_CODE: 'businessCode', // מספר חברה (ח.פ.)
    BUSINESS_NAME: 'businessName', // שם חברה
}

/**
 * User Event Fields - Actual field names used in form data and API payloads
 * These are the keys used when submitting user/attendee information in order forms
 * Reuses GeneralFieldsName values where they match, overrides where different
 * Note: Different from GeneralFieldsName which represents backend configuration field identifiers
 */
export const UserEventFields = {
    FIRST_NAME: GeneralFieldsName.F_NAME,           // 'fname'
    LAST_NAME: GeneralFieldsName.L_NAME,            // 'lname'
    PHONE: GeneralFieldsName.PHONE,                 // 'phone'
    EMAIL: GeneralFieldsName.EMAIL,                 // 'email'
    BIRTH_DATE: 'birth_date',                       // Different from B_DAY ('birthday')
    GENDER: GeneralFieldsName.GENDER,               // 'gender'
    SOCIAL_LINK: 'social_link',                     // Different from SOCIAL_LINK ('socialLink')
    BUSINESS_CODE: GeneralFieldsName.BUSINESS_CODE, // 'businessCode'
    BUSINESS_NAME: GeneralFieldsName.BUSINESS_NAME, // 'businessName'
}

export const FieldsTypes = {
    DATE_NO_TIME: 'date_no_time',
    STRING: 'string',
    YES_OR_NO: 'boolean',
    CHECKBOX: 'checkbox',
    // For business fields, use STRING type
    BUSINESS_CODE: 'string',
    BUSINESS_NAME: 'string',
}

export const PaymeFileTypes = {
    SOCIAL_ID: 1,
    BANK_ACCOUNT_OWNERSHIP: 2,
    CORPORATE_CERTIFICATE: 3
}

export const PAYME_HOSTED_FIELDS_SCRIPT_URL = 'https://cdn.payme.io/hf/v1/hostedfields.js'

export const FeeCollectionTypes = {
    PERCENTAGE_FROM_TICKET: "percentage_from_ticket",
    ON_TOP_OF_TICKET: "on_top_of_ticket"
}

export const SocialNetworks = {
    FACEBOOK: 'facebook',
    INSTAGRAM: 'instagram',
    LINKEDIN: 'linkedin',
    TWITTER: 'twitter',
    TIKTOK: 'tiktok',
    YOUTUBE: 'youtube',
    WHATSAPP: 'whatsapp',
    TELEGRAM: 'telegram',
}

export const SocialNetworkLabels = {
    [SocialNetworks.FACEBOOK]: 'Facebook',
    [SocialNetworks.INSTAGRAM]: 'Instagram',
    [SocialNetworks.LINKEDIN]: 'LinkedIn',
    [SocialNetworks.TWITTER]: 'Twitter',
    [SocialNetworks.TIKTOK]: 'TikTok',
    [SocialNetworks.YOUTUBE]: 'YouTube',
    [SocialNetworks.WHATSAPP]: 'WhatsApp',
    [SocialNetworks.TELEGRAM]: 'Telegram',
}

export const IEventTypeEnum = {
    TRANCE_PARTY: 'trance-party',
    TECHNO_PARTY: 'techno-party',
    ELECTRONIC_PARTY: 'electronic-party',
    CULTURE: 'culture',
    SPORT: 'sport',
    BUSINESS: 'business',
    LECTURER: 'lecturer',
    EDUCATION: 'education',
    CHARITY: 'charity',
    OTHER: 'other',
    WELLNESS: 'wellness',
    MUSIC: 'music'
};

export const SellerPageEventFilterUIElements = {
    DROPDOWN: 'dropdown',
    TABS: 'tabs',
    BUTTONS: 'buttons',
    BUTTON_GROUP: 'button-group',
};

export const SellerPageEventFilterUIElementLabels = {
    [SellerPageEventFilterUIElements.DROPDOWN]: 'dropdown',
    [SellerPageEventFilterUIElements.TABS]: 'tabs',
    [SellerPageEventFilterUIElements.BUTTONS]: 'buttons',
    [SellerPageEventFilterUIElements.BUTTON_GROUP]: 'button-group',
};

export const isValidSellerPageEventFilterUIElement = (value) => {
    return Object.values(SellerPageEventFilterUIElements).includes(value);
};

export const getUIElementType = (uiElement) => {
    switch (uiElement) {
        case SellerPageEventFilterUIElements.TABS:
            return 'tabs';
        case SellerPageEventFilterUIElements.BUTTONS:
            return 'buttons';
        case SellerPageEventFilterUIElements.BUTTON_GROUP:
            return 'button-group';
        case SellerPageEventFilterUIElements.DROPDOWN:
        default:
            return 'dropdown';
    }
};

/**
 * Ticket types the SYSTEM creates and owns. They are never sellable, never pickable by staff, and
 * must never reach a buyer:
 *  - SystemFreeTicket — the free/special-ticket feature, distributed by link.
 *  - GroupCapacity    — the hidden per-event ticket a group order's captured seats sit on (#1002).
 *
 * Do NOT gate these on `is_enabled`. The ticket response schema declares it a string while the model
 * stores a boolean, so the wire value is "false" and `is_enabled !== false` is always true — a dead
 * check. The type is the only reliable discriminator.
 */
export const TicketTypes = { SYSTEM_FREE: 'SystemFreeTicket', GROUP_CAPACITY: 'GroupCapacity' };

const SYSTEM_TICKET_TYPES = [TicketTypes.SYSTEM_FREE, TicketTypes.GROUP_CAPACITY];

/**
 * Staff-picker rule: hide both. The cashier, the admin new-order dialog and the seats-chart
 * ticket editor have always hidden SystemFreeTicket, and GroupCapacity joins it.
 * Optional-chained on purpose: getTicket() is a raw map lookup that can miss.
 */
export const isSystemTicket = (ticket) => SYSTEM_TICKET_TYPES.includes(ticket?.type);

export const excludeSystemTickets = (tickets = []) => tickets.filter((t) => !isSystemTicket(t));

/**
 * A ticket the seller switched off. The response schema serializes `is_enabled` as a STRING
 * ("false") while the model stores a boolean, so both shapes must be checked — same rule the
 * public page applies in eventService.getEventPageData. Staff SALE surfaces (cashier picker,
 * new-order dialog) must hide these; the seats-chart ticket EDITOR must not, disabled tickets
 * are edited there.
 */
export const isTicketDisabled = (ticket) => ticket?.is_enabled === false || ticket?.is_enabled === 'false';

/**
 * BUYER rule — deliberately narrower, and the difference matters.
 *
 * `GroupCapacity` must never reach a buyer under any circumstances: it is a ₪0 ticket the backend
 * creates to hold a group's seats, and anyone who reached it would walk in free.
 *
 * `SystemFreeTicket` is different. It looks similar — hidden, ₪0 — but it is a DISTRIBUTION
 * mechanism: staff attach it to an event link and send that link out. Production has 87 of them and
 * three event links exposing one, two of those links live and one with 18 tickets already sold.
 * Filtering it from the public page would silently break those links, so only the capacity ticket
 * is excluded here.
 */
export const isBuyerHiddenTicket = (ticket) => ticket?.type === TicketTypes.GROUP_CAPACITY;
